// Major cities per Nigerian state — curated list. Add freely.
export const NIGERIA_STATES = {
  Abia: ["Umuahia", "Aba", "Arochukwu", "Ohafia"],
  Adamawa: ["Yola", "Mubi", "Numan", "Jimeta"],
  "Akwa Ibom": ["Uyo", "Eket", "Ikot Ekpene", "Oron"],
  Anambra: ["Awka", "Onitsha", "Nnewi", "Ekwulobia"],
  Bauchi: ["Bauchi", "Azare", "Misau"],
  Bayelsa: ["Yenagoa", "Brass", "Sagbama"],
  Benue: ["Makurdi", "Gboko", "Otukpo"],
  Borno: ["Maiduguri", "Biu", "Bama"],
  "Cross River": ["Calabar", "Ikom", "Ogoja"],
  Delta: ["Asaba", "Warri", "Sapele", "Ughelli"],
  Ebonyi: ["Abakaliki", "Afikpo", "Onueke"],
  Edo: ["Benin City", "Auchi", "Ekpoma"],
  Ekiti: ["Ado-Ekiti", "Ikere", "Ijero"],
  Enugu: ["Enugu", "Nsukka", "Awgu"],
  "FCT (Abuja)": ["Abuja", "Gwagwalada", "Kuje", "Bwari", "Kubwa"],
  Gombe: ["Gombe", "Kaltungo", "Billiri"],
  Imo: ["Owerri", "Orlu", "Okigwe"],
  Jigawa: ["Dutse", "Hadejia", "Birnin Kudu"],
  Kaduna: ["Kaduna", "Zaria", "Kafanchan"],
  Kano: ["Kano", "Wudil", "Gwarzo"],
  Katsina: ["Katsina", "Daura", "Funtua"],
  Kebbi: ["Birnin Kebbi", "Argungu", "Yauri"],
  Kogi: ["Lokoja", "Okene", "Idah"],
  Kwara: ["Ilorin", "Offa", "Omu-Aran"],
  Lagos: ["Ikeja", "Lekki", "Victoria Island", "Yaba", "Surulere", "Ikorodu", "Epe", "Badagry", "Ajah"],
  Nasarawa: ["Lafia", "Keffi", "Akwanga"],
  Niger: ["Minna", "Bida", "Suleja", "Kontagora"],
  Ogun: ["Abeokuta", "Ijebu Ode", "Sagamu", "Ota"],
  Ondo: ["Akure", "Ondo", "Owo", "Ikare"],
  Osun: ["Osogbo", "Ile-Ife", "Ilesa", "Ede"],
  Oyo: ["Ibadan", "Ogbomoso", "Iseyin", "Oyo"],
  Plateau: ["Jos", "Bukuru", "Pankshin"],
  Rivers: ["Port Harcourt", "Bonny", "Bori", "Omoku"],
  Sokoto: ["Sokoto", "Tambuwal", "Wurno"],
  Taraba: ["Jalingo", "Wukari", "Bali"],
  Yobe: ["Damaturu", "Potiskum", "Gashua"],
  Zamfara: ["Gusau", "Kaura Namoda", "Talata Mafara"],
};

export const STATE_LIST = Object.keys(NIGERIA_STATES).sort();
